exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".job-company-small-infor {\n  width: 100%;\n  height: auto;\n  margin-bottom: 32px; }\n  .job-company-small-infor .detail-small-title {\n    margin: 10px 0px 25px 0px;\n    border-left: 2px solid #737980;\n    padding-left: 10px;\n    font-size: 16px;\n    color: #17181a; }\n  .job-company-small-infor > div > img {\n    cursor: pointer;\n    width: 80px;\n    height: 80px;\n    margin-bottom: 20px;\n    transition: all 300ms ease-in-out;\n    transform: scale(1);\n    display: inline-block; }\n  .job-company-small-infor > div > img:hover {\n    transform: scale(1.1); }\n  .job-company-small-infor .company-name {\n    margin: -2px 0 10px 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size: 16px;\n    color: #17181a;\n    cursor: pointer; }\n  .job-company-small-infor .company-name:hover {\n    color: #14cc9e; }\n  .job-company-small-infor .company-text {\n    color: #737980;\n    margin: 12px 0; }\n  .job-company-small-infor > div:last-child {\n    margin-bottom: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/job/job-company-small-infor/job-company-small-infor.component.scss
// module id = ../../../../../src/app/job/job-company-small-infor/job-company-small-infor.component.scss
// module chunks = job.module